<script async setup lang="ts">
import { useContactStore } from '@/stores/contact.store';
import Info from '../ui/InfoComponent.vue';
import { computed } from 'vue';

const contactStore = useContactStore();
const contact = contactStore.getContact;

const data = computed(() => {
  return [
    {
      link: `tel:${contact.value?.phone}`,
      title: `+ ${contact.value?.phone}`,
      img: {
        src: '/assets/icons/phone.svg',
        alt: 'Телефон'
      },
      copy: String(contact.value?.phone)
    },
    {
      link: `mailto:${contact.value?.email}`,
      title: contact.value?.email,
      img: {
        src: '/assets/icons/mail.svg',
        alt: 'Почта'
      },
      copy: contact.value?.email
    }
  ];
});
</script>

<template>
  <section class="contacts">
    <article class="contact-us">
      <h3>Хочешь узнать больше?<br />Свяжитесь с нами</h3>
      <div class="contacts-list">
        <Info v-for="item in data" :key="item.title" v-bind="item" />
      </div>
    </article>
    <article class="telegram">
      <a
        href="https://t.me/aeb_course"
        target="_blank"
        class="telegram-content"
      >
        <img src="/assets/icons/telegram.svg" alt="" />
        <p>Присоединяйтесь <br />к нашему каналу</p>
      </a>
      <div class="telegram-qr">
        <img src="/assets/icons/telegram-qr.svg" alt="QR код телеграм" />
      </div>
    </article>
  </section>
</template>

<style scoped lang="scss">
.contacts {
  gap: 40px;
  display: flex;

  .contact-us {
    gap: 24px;
    flex: 1 800px;
    display: flex;
    flex-direction: column;
    padding: 40px 40px 40px 64px;

    h3 {
      font-size: var(--font-size-lm);
      line-height: var(--font-size-lg);
    }

    .contacts-list {
      gap: 16px;
      display: flex;
      justify-content: space-between;
    }
  }

  .telegram {
    flex: 1 560px;
  }

  .contact-us,
  .telegram {
    border-radius: 40px;
    background: var(--color-mono-10);
  }

  .telegram {
    gap: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    &-content {
      gap: 12px;
      height: 200px;
      display: flex;
      padding: 0 20px;
      border-radius: 32px;
      flex-direction: column;
      justify-content: center;
      background: var(--color-mono-50);

      img {
        width: 56px;
        padding: 12px;
        border-radius: 20px;
        color: var(--color-mono-900);
        background: var(--color-mono-0);
      }

      p {
        font-weight: var(--font-weight-light);
      }
    }

    &-qr {
      height: 200px;
      padding: 20px;
      user-select: none;
      border-radius: 32px;
      background: var(--color-mono-0);
    }
  }
}

@media screen and (max-width: 1600px) {
  .contacts {
    .contacts-list {
      flex-direction: column;
    }

    .telegram {
      flex: 1;
      padding: 24px;
      width: auto;
    }
  }
}

@media screen and (max-width: 1024px) {
  .contacts {
    gap: 24px;
    flex-direction: column;

    .contact-us {
      flex: 1;
      padding: 40px 24px 24px;
    }

    .contacts-list {
      flex-direction: column;
    }

    .telegram {
      flex: 1;
      padding: 24px;
      flex-direction: column;

      .telegram-content {
        width: 100%;
        height: auto;
        padding: 20px;
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
      }
    }
  }
}

@media screen and (max-width: 380px) {
  .contact-us {
    padding: 40px 18px 24px;
  }

  .telegram-content {
    padding: 12px !important;
    border-radius: 20px !important;

    p {
      font-size: var(--font-size-s);
    }

    img {
      width: 48px !important;
      height: 48px !important;
    }
  }
}
</style>
